export const CASHBOX_TYPES = {
  MAIN: 'main',
  REGISTER: 'register',
  SAFE: 'safe',
  ACCOUNT: 'account',
};

export const CASHBOX_TYPES_UA = {
  [CASHBOX_TYPES.MAIN]: 'Головний рахунок',
  [CASHBOX_TYPES.REGISTER]: 'Каса локації',
  [CASHBOX_TYPES.SAFE]: 'Рахунок локації',
  [CASHBOX_TYPES.ACCOUNT]: 'Банківський рахунок',
};
